import UpdateNotesTemplateModal from "./UpdateNotesTemplateModal";

export default UpdateNotesTemplateModal;
